import React from "react"
import { formatMoney } from "../../../utils/money"
import Typography from "../../atoms/Typography"
import { SanityImg } from "../../../cms/components"

export interface GiftcardRecapProps {
  imageAsset: string
  code: string
  amount: number
}

const GiftcardRecap = ({ imageAsset, code, amount }: GiftcardRecapProps) => {
  return (
    <div className="text-center">
      <div className="max-w-[300px]">
        <SanityImg fluid asset={imageAsset} />
      </div>
      <Typography variant="h5">{code}</Typography>
      <Typography variant="body1">
        {formatMoney({
          amount,
          currency: "eur",
        })}
      </Typography>
    </div>
  )
}

export default GiftcardRecap
